import { useSyncExternalStore } from 'react';

/**
 * Mijoz sessiyasi — kuzatiladigan holat mashinasi.
 *
 * To'rtta holat:
 *   - `initializing` — server bilan handshake ketmoqda
 *   - `authenticated` — server IMZONI tasdiqladi, tokenlar qo'yilgan
 *   - `guest`         — Telegramdan tashqarida yoki SDK yo'q, urinish
 *                       UMUMAN bo'lmagan (`Bootstrap` qarang)
 *   - `failed`        — handshake muvaffaqiyatsiz tugadi, qayta urinish
 *                       mumkin
 *
 * Holat BITTA modulda, boshqa hech qayerda takrorlanmaydi — `App.tsx`
 * faqat shu yerdagi o'tish funksiyalarini chaqiradi.
 */
export type SessionStatus = 'initializing' | 'authenticated' | 'guest' | 'failed';

let status: SessionStatus = 'initializing';
const listeners = new Set<() => void>();

function setStatus(next: SessionStatus): void {
  if (status === next) return;
  status = next;
  for (const listener of listeners) listener();
}

/** Joriy holat — sinxron o'qish (test va `useSyncExternalStore` uchun). */
export function getSessionStatus(): SessionStatus {
  return status;
}

/** Holat o'zgarganda xabar oladi. `useSyncExternalStore` uchun mo'ljallangan. */
export function subscribeSession(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Reaktiv o'qish — komponent holat o'zgarganda qayta chiziladi. */
export function useSessionStatus(): SessionStatus {
  return useSyncExternalStore(subscribeSession, getSessionStatus);
}

export function setInitializing(): void {
  setStatus('initializing');
}

export function setAuthenticated(): void {
  setStatus('authenticated');
}

export function setGuest(): void {
  setStatus('guest');
}

export function setFailed(): void {
  setStatus('failed');
}

/**
 * Ilova mijoz nomidan ish qila oladimi.
 *
 * FAQAT server handshake'i MUVAFFAQIYATLI tugagan bo'lsa (`authenticated`)
 * `true`. `initData` bo'sh emasligi yoki Telegram SDK borligi —
 * autentifikatsiya EMAS, shuning uchun bu yerdan ULAR SO'RALMAYDI.
 *
 * Ishga tushganda va xato/kutilayotgan holatda — FAIL-CLOSED: `false`.
 */
export function canOrder(): boolean {
  return status === 'authenticated';
}
